import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { POSE_BACKEND } from '@config/features';
import { useMediaPipeStore } from '@/zustand/media-pipe-store';

const MOVEX_BUILDER_ROUTE = '/movex-builder';

function scheduleIdleInitialization(callback) {
  if (typeof window === 'undefined') {
    callback();
    return () => {};
  }

  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(callback, { timeout: 2000 });
    return () => {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
    };
  }

  const timeoutId = window.setTimeout(callback, 250);
  return () => window.clearTimeout(timeoutId);
}

const MediaPipeBootstrap = () => {
  const initializePoseLandmark = useMediaPipeStore(state => state.initializePoseLandmark);
  const { pathname } = useLocation();
  // Remote pose runs no MediaPipe on the patient pages (30.7 MB model + 9 MB wasm): only the builder needs it.
  const needed = POSE_BACKEND !== 'remote' || pathname === MOVEX_BUILDER_ROUTE;

  useEffect(() => {
    if (!needed) {
      return undefined;
    }
    const cancelIdleInitialization = scheduleIdleInitialization(() => {
      void initializePoseLandmark();
    });

    return () => {
      cancelIdleInitialization();
    };
  }, [initializePoseLandmark, needed]);

  return null;
};

export default MediaPipeBootstrap;
